module.exports = __webpack_public_path__ + "static/media/wishlist-black.b4e9168a.svg";